document.documentElement.classList.add('js-ready');

const waitlistSuccessUrl = new URL(window.location.href);
const isWaitlistThankYou = waitlistSuccessUrl.searchParams.get('waitlist') === 'thank-you';

if (isWaitlistThankYou) {
  const successForm = document.querySelector('[data-klaviyo-waitlist]');
  const successMessage = successForm?.querySelector('[data-success-message]');

  if (successMessage) {
    successMessage.hidden = false;
    successMessage.focus();
  }
}

const waitlistForms = document.querySelectorAll('[data-klaviyo-waitlist]');

waitlistForms.forEach((form) => {
  form.addEventListener('submit', async (event) => {
    event.preventDefault();

    const button = form.querySelector('button[type="submit"]');
    const successMessage = form.querySelector('[data-success-message]');
    const errorMessage = form.querySelector('[data-error-message]');
    const formData = new FormData(form);
    const email = String(formData.get('email') || '').trim();
    const firstName = String(formData.get('first_name') || '').trim();
    const publicKey = form.dataset.klaviyoPublicKey;
    const listId = form.dataset.klaviyoListId;

    successMessage.hidden = true;
    errorMessage.hidden = true;

    if (!email || !publicKey || !listId) {
      errorMessage.textContent = 'Please enter a valid email address.';
      errorMessage.hidden = false;
      errorMessage.focus();
      return;
    }

    button.disabled = true;
    button.dataset.originalText = button.textContent;
    button.textContent = 'Joining...';

    const payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'KinderLayer Shopify waitlist form',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email,
                first_name: firstName || undefined,
                subscriptions: {
                  email: {
                    marketing: {
                      consent: 'SUBSCRIBED'
                    }
                  }
                }
              },
              properties: {
                source: 'KinderLayer Shopify waitlist form'
              }
            }
          }
        },
        relationships: {
          list: {
            data: {
              type: 'list',
              id: listId
            }
          }
        }
      }
    };

    try {
      const response = await fetch(
        `https://a.klaviyo.com/client/subscriptions?company_id=${encodeURIComponent(publicKey)}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/vnd.api+json',
            revision: '2026-04-15'
          },
          body: JSON.stringify(payload)
        }
      );

      if (!response.ok) {
        throw new Error(`Klaviyo returned ${response.status}`);
      }

      await fetch(
        `https://a.klaviyo.com/client/events?company_id=${encodeURIComponent(publicKey)}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/vnd.api+json',
            revision: '2026-04-15'
          },
          body: JSON.stringify({
            data: {
              type: 'event',
              attributes: {
                properties: {
                  source: 'KinderLayer Shopify waitlist form',
                  list_id: listId,
                  form_location: form.id || 'waitlist-form'
                },
                unique_id: `${email.toLowerCase()}-${Date.now()}`,
                metric: {
                  data: {
                    type: 'metric',
                    attributes: {
                      name: 'Joined VIP Waitlist'
                    }
                  }
                },
                profile: {
                  data: {
                    type: 'profile',
                    attributes: {
                      email,
                      first_name: firstName || undefined
                    }
                  }
                }
              }
            }
          })
        }
      );

      const redirectUrl = new URL(window.location.href);
      redirectUrl.pathname = '/';
      redirectUrl.search = '?waitlist=thank-you';
      redirectUrl.hash = 'waitlist';
      window.location.assign(redirectUrl.toString());
    } catch {
      errorMessage.textContent = 'Something went sideways. Please try again.';
      errorMessage.hidden = false;
      errorMessage.focus();
    } finally {
      button.disabled = false;
      button.textContent = button.dataset.originalText || 'Join the waitlist';
    }
  });
});
